import { Injectable } from '@angular/core';
import { LocalizedDateService } from '@sondermind/utilities/time-and-date';
import { ISupportResources } from '../models/support-resources.interface';
import {
  AMERICA_SUPPORT_RESOURCES,
  AUSTRALIA_SUPPORT_RESOURCES,
  SupportedLocales
} from '../constants/support-resources-by-locale.constant';

/**
 * Service that provides SonderMind support resources and emergency contact information,
 * appropriately handling that these resources can differ by locale.
 */
@Injectable({ providedIn: 'root' })
export class LocalizedSupportResourceService {
  constructor(
    private localizedDateService: LocalizedDateService
  ) {}

  getSupportResources(): ISupportResources {
    const locale = this.localizedDateService.getBrowserLocale();
    if (locale === SupportedLocales.AUSTRALIA) {
      return AUSTRALIA_SUPPORT_RESOURCES;
    }

    return AMERICA_SUPPORT_RESOURCES;
  }

  getEmergencyServicesPhoneNumber(): string {
    return this.getSupportResources().emergencyServicesPhoneNumber;
  }

  isUserLocaleOutsideAmerica(): boolean {
    return this.localizedDateService.getBrowserLocale() !== SupportedLocales.AMERICA;
  }
}
